// MapUtils.js
export const getAllCoords = (coords) => {
  if (!Array.isArray(coords)) return [];
  if (typeof coords[0] === "number") return [coords]; // [lng, lat]
  return coords.flatMap(getAllCoords); // recursively flatten
};